import { z } from "zod";

// ==========================================
// #region ÁGUA
// ==========================================

export const ControleAguaSchema = z.object({
  idObra: z.number().nullish(),
  idControleAgua: z.number().nullish(),
  ano: z.coerce.number().nullish(),
  idDescricaoMes: z.coerce.number().nullish(),
  volumeM3: z.coerce.number().nullish(),
  valor: z.coerce.number().nullish(),
  efetivoMes: z.coerce.number().nullish(),
  mediaTrabalhador: z.coerce.number().nullish(),
  areaConstruida: z.coerce.number().nullish(),
  mediaArea: z.coerce.number().nullish(),
  metaAprovacao: z.coerce.number().nullish(),
  diasMedicao: z.coerce.number().nullish(),
  observacao: z.coerce.string().nullish(),
});

export type ControleAguaForm = z.infer<typeof ControleAguaSchema>;

// #endregion
